export const VirtualPaymentGlobalContext = 'virtualPaymentGlobalContext';
